import { IApplicationState } from '../../../../../../../types/types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { root } from '../../../../../../../store/constants';
import { FEATURE_POLL_FIRST_VISIT_COOKIE_NAME, TEMPLATE_BOARD_ID_SESSIONSTORAGE } from '../constants';
import { getActiveBoard } from '../../../../../../../store/model/selectors/getActiveBoard';

export const getShowTemplatePoll = (state: IApplicationState): boolean => {
    const authUser = getAuthUser(state);
    const firstVisit = authUser.firstVisit && root.App.Util.getCookie(FEATURE_POLL_FIRST_VISIT_COOKIE_NAME) === undefined;
    const activeBoard = getActiveBoard(state);
    const templateBoardId = sessionStorage.getItem(TEMPLATE_BOARD_ID_SESSIONSTORAGE);
    return firstVisit && templateBoardId && activeBoard && activeBoard.copiedFromId !== Number(templateBoardId);
}
